import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'

import { saga as apiSaga } from '@signavio/effektif-api'

import rootReducer from '../reducers'

const NODE_ENV = process.env.NODE_ENV

export default function configureStore() {
  const sagaMiddleware = createSagaMiddleware()

  const finalCreateStore = compose(
    applyMiddleware(sagaMiddleware),
    NODE_ENV === 'development' && window.devToolsExtension
      ? window.devToolsExtension()
      : (f) => f
  )(createStore)

  const store = finalCreateStore(rootReducer, {})
  sagaMiddleware.run(apiSaga, store.getState)

  if (NODE_ENV === 'development' && module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default // eslint-disable-line global-require
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}
